import { getUniqueId } from "modules/utils/getUniqueId";

export const CollectibleCacheTags = {
  main: getUniqueId(),
};
